<template>
  <div>
    <v-dialog v-model="open" persistent max-width="640px" :hide-overlay="this.$route.fullPath.includes('details')"
              attach="RealizationModal">
      <v-card>
        <form @submit.prevent="!isProcessing ? onSubmit() : null">
          <v-card-title><span class="headline">Edycja vouchera</span></v-card-title>
          <v-card-text>
            <v-container class="pt-0" grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Imię i nazwisko"
                    v-model="formData.name"
                    browser-autocomplete="off">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 v-permissions>
                  <v-autocomplete
                    :items="getVouchersTypeList"
                    label="Nazwa vouchera"
                    data-vv-name="nazwa vouchera"
                    v-model="formData.type_id"
                    item-text="name"
                    item-value="id"
                    :error-messages="errors.collect('nazwa vouchera')"
                    v-validate="'required'"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 v-permissions>
                  <v-text-field
                    label="Nr faktury/paragonu"
                    v-model="formData.invoice_number"
                    browser-autocomplete="off">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Opis usługi"
                    box
                    text-area
                    v-model="formData.service_type"
                    data-vv-name="opis usługi"
                    :error-messages="errors.collect('opis usługi')"
                    browser-autocomplete="off">
                  </v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Notatka wewnętrzna"
                    box
                    text-area
                    v-model="formData.internal_note"
                    data-vv-name="notatka wewnętrzna"
                    :error-messages="errors.collect('Notatka wewnętrzna')"
                    browser-autocomplete="off">
                  </v-textarea>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-checkbox
                    label="Pokaż cenę vouchera"
                    v-model="formData.show_price"
                    browser-autocomplete="off">
                  </v-checkbox>
                </v-flex>
<!--                <v-flex xs12 sm6>-->
<!--                  <v-checkbox-->
<!--                    label="Faktura do vouchera"-->
<!--                    v-model="formData.has_invoice"-->
<!--                    browser-autocomplete="off">-->
<!--                  </v-checkbox>-->
<!--                </v-flex>-->
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" flat @click="goBack">Anuluj</v-btn>
            <v-btn color="blue darken-1" flat :disabled="isProcessing" type="submit">Zapisz</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  /* eslint-disable no-unused-expressions */

  import {mapActions, mapGetters} from 'vuex';
  import {clearEmptyFields} from '../../helpers/clearEmptyFields';

  export default {
    name: 'EditVoucher',
    data() {
      return {
        formData: {},
        open: true,
        isProcessing: false,
      };
    },
    beforeMount() {
      this.fetchVoucherDetails(this.$route.params.voucherId)
        .then((response) => {
          this.formData = response;
        });
    },
    computed: {
      ...mapGetters('VoucherTypeStore', ['getVouchersTypeList']),
      ...mapGetters('AuthStore', ['getUserRole']),
    },
    methods: {
      ...mapActions('VoucherStore', ['editVoucher', 'fetchVoucherDetails']),
      goBack() {
        this.$route.fullPath.includes('details') ? this.$router.push({
          name: 'VoucherDetails',
          params: {voucherId: this.$route.params.voucherId},
        }) : this.$router.push({name: 'Vouchers'});
      },
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              const formatedData = clearEmptyFields(Object.assign({}, this.formData));
              let formData = {
                id: formatedData.id,
                name: formatedData.name ? formatedData.name : '',
                internal_note: formatedData.internal_note ? formatedData.internal_note : null,
                service_type: formatedData.service_type ? formatedData.service_type : null,
                show_price: formatedData.show_price !== null && formatedData.show_price !== undefined ? Boolean(formatedData.show_price) : null
              };
              if (this.getUserRole === 'A') {
                formData = {
                  ...formData,
                  type_id: formatedData.type_id,
                  invoice_number: formatedData.invoice_number,
                  service_type: formatedData.service_type,
                };
              }
              this.editVoucher(formData)
                .then(() => {
                  this.isProcessing = false;
                  this.formData = {};
                  this.goBack();
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
